import { ApiError } from '../../services/api/apiClient.types.js';
import { CachedRequestFailureError } from './requestFailureCache.js';

/**
 * True for deny-cache / request-failure skip errors whose `.message` is internal
 * (e.g. "Skipping cached failure for GET|…", "Skipping denied request (in-session)")
 * and must never render in operator UI or toasts.
 */
export function isInternalApiSkipError(error: unknown): boolean {
  if (error instanceof CachedRequestFailureError) {
    return true;
  }
  if (error instanceof ApiError && error.code === 'API_DENY_CACHED') {
    return true;
  }
  if (!(error instanceof Error)) {
    return false;
  }
  if (error.name === 'AdminSwrCachedFailureError') {
    return true;
  }
  return (
    error.message.startsWith('Skipping cached failure')
    || error.message.startsWith('Skipping denied request')
  );
}
